export default __webpack_public_path__ + "static/media/Group011991.47ac00b9.svg";